<template>
    <div class="orion-card">
        <div v-if="showHeader" class="orion-card_header">
            <div class="title">
                <slot name="title">{{ title }}</slot>
            </div>
            <div>
                <slot name="header-right"></slot>
            </div>
        </div>
        <div class="orion-card_body">
            <slot></slot>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { computed, useSlots } from 'vue';

defineOptions({
    name: 'OCard',
    inheritAttrs: false
})

const slots = useSlots()
const { title } = defineProps<{ title?: string }>()
const showHeader = computed(() => title || slots['title'] || slots['header-right'])
</script>

<style lang="scss" scoped>
.orion-card {
    background-color: var(--orion-card-background-color);
    box-sizing: border-box;
    border: 1px solid var(--orion-card-border-color);
    border-radius: 4px;
    color: var(--orion-card-font-color);
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;

    .orion-card_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: var(--orion-card-padding);

        .title {
            font-size: 18px;
            font-weight: bold;
        }
    }

    .orion-card_body {
        flex: 1;
        padding: var(--orion-card-padding);
        overflow: auto;
    }
}
</style>